import { useEffect } from 'react'

const IssueNatureQuestion = ({ formData, setFormData, questionState, setQuestionState }) => {

    useEffect(() => {
        const existingResponses = formData.form_responses?.question2?.responses || [];
        if (existingResponses.length > 0) {
            const newState = { ...questionState };

            existingResponses.forEach(response => {
                if (newState[response.answer_text]) {
                    newState[response.answer_text].selected = true;

                    if (response.sub_responses && response.sub_responses.length > 0) {
                        response.sub_responses.forEach(subResponse => {
                            if (newState[response.answer_text].subOptions && newState[response.answer_text].subOptions[subResponse.answer_text]) {
                                newState[response.answer_text].subOptions[subResponse.answer_text].selected = true;

                                if (subResponse.sub_responses && subResponse.sub_responses.length > 0) {
                                    subResponse.sub_responses.forEach(subSubResponse => {
                                        if (newState[response.answer_text].subOptions[subResponse.answer_text].subOptions &&
                                            newState[response.answer_text].subOptions[subResponse.answer_text].subOptions[subSubResponse.answer_text]) {
                                            newState[response.answer_text].subOptions[subResponse.answer_text].subOptions[subSubResponse.answer_text].selected = true;

                                            if (subSubResponse.text_response) {
                                                newState[response.answer_text].subOptions[subResponse.answer_text].subOptions[subSubResponse.answer_text].text_response = subSubResponse.text_response;
                                            }
                                        }
                                    });
                                }

                                if (subResponse.selection) {
                                    newState[response.answer_text].subOptions[subResponse.answer_text].selection = subResponse.selection;
                                }
                                if (subResponse.text_response) {
                                    newState[response.answer_text].subOptions[subResponse.answer_text].text_response = subResponse.text_response;
                                }
                            }
                        });
                    }

                    if (response.text_response) {
                        newState[response.answer_text].text_response = response.text_response;
                    }
                }
            });

            setQuestionState(newState);
        }
    }, [formData.form_responses?.question2?.responses])

    const uncheckSubOptions = (options) => {
        if (!options || typeof options !== 'object') return options;

        const updatedOptions = { ...options };
        Object.keys(updatedOptions).forEach(key => {
            if (updatedOptions[key] && typeof updatedOptions[key] === 'object') {
                updatedOptions[key] = {
                    ...updatedOptions[key],
                    selected: false
                };
                if (updatedOptions[key].subOptions) {
                    updatedOptions[key].subOptions = uncheckSubOptions(updatedOptions[key].subOptions);
                }
            }
        });
        return updatedOptions;
    };

    const handleQuestionUpdate = (responseKey, checkedValue, parentKey = null, dataKey = null, value = null, grandParentKey = null) => {
        setQuestionState(prevState => {
            const newState = { ...prevState };

            if (dataKey) {
                if (grandParentKey && parentKey) {

                    if (!newState[grandParentKey]) {
                        newState[grandParentKey] = { selected: false, subOptions: {} };
                    }

                    if (!newState[grandParentKey].subOptions) {
                        newState[grandParentKey].subOptions = {};
                    }

                    if (!newState[grandParentKey].subOptions[parentKey]) {
                        newState[grandParentKey].subOptions[parentKey] = { selected: false, subOptions: {} };
                    }

                    if (!newState[grandParentKey].subOptions[parentKey].subOptions) {
                        newState[grandParentKey].subOptions[parentKey].subOptions = {};
                    }

                    if (!newState[grandParentKey].subOptions[parentKey].subOptions[responseKey]) {
                        newState[grandParentKey].subOptions[parentKey].subOptions[responseKey] = { selected: false };
                    }

                    newState[grandParentKey] = {
                        ...newState[grandParentKey],
                        subOptions: {
                            ...newState[grandParentKey].subOptions,
                            [parentKey]: {
                                ...newState[grandParentKey].subOptions[parentKey],
                                subOptions: {
                                    ...newState[grandParentKey].subOptions[parentKey].subOptions,
                                    [responseKey]: {
                                        ...newState[grandParentKey].subOptions[parentKey].subOptions[responseKey],
                                        [dataKey]: value
                                    }
                                }
                            }
                        }
                    };
                } else if (parentKey) {

                    if (!newState[parentKey]) {
                        newState[parentKey] = { selected: false, subOptions: {} };
                    }

                    if (!newState[parentKey].subOptions) {
                        newState[parentKey].subOptions = {};
                    }

                    if (!newState[parentKey].subOptions[responseKey]) {
                        newState[parentKey].subOptions[responseKey] = { selected: false };
                    }

                    newState[parentKey] = {
                        ...newState[parentKey],
                        subOptions: {
                            ...newState[parentKey].subOptions,
                            [responseKey]: {
                                ...newState[parentKey].subOptions[responseKey],
                                [dataKey]: value
                            }
                        }
                    };
                } else {

                    if (!newState[responseKey]) {
                        newState[responseKey] = { selected: false };
                    }
                    newState[responseKey] = {
                        ...newState[responseKey],
                        [dataKey]: value
                    };
                }
            } else if (grandParentKey && parentKey) {
                if (!newState[grandParentKey]) {
                    newState[grandParentKey] = { selected: false, subOptions: {} };
                }
                if (!newState[grandParentKey].subOptions) {
                    newState[grandParentKey].subOptions = {};
                }
                if (!newState[grandParentKey].subOptions[parentKey]) {
                    newState[grandParentKey].subOptions[parentKey] = { selected: false, subOptions: {} };
                }
                if (!newState[grandParentKey].subOptions[parentKey].subOptions) {
                    newState[grandParentKey].subOptions[parentKey].subOptions = {};
                }
                if (!newState[grandParentKey].subOptions[parentKey].subOptions[responseKey]) {
                    newState[grandParentKey].subOptions[parentKey].subOptions[responseKey] = { selected: false };
                }

                newState[grandParentKey] = {
                    ...newState[grandParentKey],
                    subOptions: {
                        ...newState[grandParentKey].subOptions,
                        [parentKey]: {
                            ...newState[grandParentKey].subOptions[parentKey],
                            subOptions: {
                                ...newState[grandParentKey].subOptions[parentKey].subOptions,
                                [responseKey]: {
                                    ...newState[grandParentKey].subOptions[parentKey].subOptions[responseKey],
                                    selected: checkedValue
                                }
                            }
                        }
                    }
                };
            } else if (parentKey) {
                if (!newState[parentKey]) {
                    newState[parentKey] = { selected: false, subOptions: {} };
                }
                if (!newState[parentKey].subOptions) {
                    newState[parentKey].subOptions = {};
                }
                if (!newState[parentKey].subOptions[responseKey]) {
                    newState[parentKey].subOptions[responseKey] = { selected: false };
                }

                newState[parentKey] = {
                    ...newState[parentKey],
                    subOptions: {
                        ...newState[parentKey].subOptions,
                        [responseKey]: {
                            ...newState[parentKey].subOptions[responseKey],
                            selected: checkedValue
                        }
                    }
                };

                if (!checkedValue && newState[parentKey].subOptions[responseKey].subOptions) {
                    newState[parentKey].subOptions[responseKey].subOptions = uncheckSubOptions(newState[parentKey].subOptions[responseKey].subOptions);
                }
            } else {
                if (!newState[responseKey]) {
                    newState[responseKey] = { selected: false };
                }
                newState[responseKey] = {
                    ...newState[responseKey],
                    selected: checkedValue
                };

                if (!checkedValue && newState[responseKey].subOptions) {
                    newState[responseKey].subOptions = uncheckSubOptions(newState[responseKey].subOptions);
                }
            }

            return newState;
        });

        setFormData(prevFormData => {
            const currentResponses = prevFormData.form_responses?.question2?.responses || [];

            if (dataKey) {
                const updatedResponses = currentResponses.map(response => {
                    if (grandParentKey && parentKey && response.answer_text === grandParentKey) {
                        return {
                            ...response,
                            sub_responses: response.sub_responses.map(subResponse => {
                                if (subResponse.answer_text === parentKey) {
                                    return {
                                        ...subResponse,
                                        sub_responses: subResponse.sub_responses.map(subSubResponse =>
                                            subSubResponse.answer_text === responseKey
                                                ? { ...subSubResponse, [dataKey]: value }
                                                : subSubResponse
                                        )
                                    };
                                }
                                return subResponse;
                            })
                        };
                    } else if (parentKey && response.answer_text === parentKey) {
                        return {
                            ...response,
                            sub_responses: response.sub_responses.map(subResponse =>
                                subResponse.answer_text === responseKey
                                    ? { ...subResponse, [dataKey]: value }
                                    : subResponse
                            )
                        };
                    } else if (!parentKey && response.answer_text === responseKey) {
                        return { ...response, [dataKey]: value };
                    }
                    return response;
                });

                return {
                    ...prevFormData,
                    form_responses: {
                        ...prevFormData.form_responses,
                        question2: {
                            question_title: "What is the main nature of the employee issue?",
                            responses: updatedResponses
                        }
                    }
                };
            } else {
                let updatedResponses = [...currentResponses];

                if (grandParentKey && parentKey) {
                    const grandParentIndex = updatedResponses.findIndex(r => r.answer_text === grandParentKey);

                    if (grandParentIndex !== -1) {
                        const grandParentResponse = updatedResponses[grandParentIndex];
                        let updatedSubResponses = [...grandParentResponse.sub_responses];

                        const parentIndex = updatedSubResponses.findIndex(sr => sr.answer_text === parentKey);

                        if (parentIndex !== -1) {
                            const parentResponse = updatedSubResponses[parentIndex];
                            let updatedSubSubResponses = [...parentResponse.sub_responses];

                            if (checkedValue) {
                                if (!updatedSubSubResponses.find(ssr => ssr.answer_text === responseKey)) {
                                    updatedSubSubResponses.push({
                                        answer_text: responseKey,
                                        sub_responses: []
                                    });
                                }
                            } else {
                                updatedSubSubResponses = updatedSubSubResponses.filter(ssr => ssr.answer_text !== responseKey);
                            }

                            updatedSubResponses[parentIndex] = {
                                ...parentResponse,
                                sub_responses: updatedSubSubResponses
                            };

                            updatedResponses[grandParentIndex] = {
                                ...grandParentResponse,
                                sub_responses: updatedSubResponses
                            };
                        }
                    }
                } else if (parentKey) {
                    const parentResponseIndex = updatedResponses.findIndex(r => r.answer_text === parentKey);

                    if (parentResponseIndex !== -1) {
                        const parentResponse = updatedResponses[parentResponseIndex];
                        let updatedSubResponses = [...parentResponse.sub_responses];

                        if (checkedValue) {
                            if (!updatedSubResponses.find(sr => sr.answer_text === responseKey)) {
                                updatedSubResponses.push({
                                    answer_text: responseKey,
                                    sub_responses: []
                                });
                            }
                        } else {
                            updatedSubResponses = updatedSubResponses.filter(sr => sr.answer_text !== responseKey);
                        }

                        updatedResponses[parentResponseIndex] = {
                            ...parentResponse,
                            sub_responses: updatedSubResponses
                        };
                    }
                } else {
                    if (checkedValue) {
                        if (!updatedResponses.find(r => r.answer_text === responseKey)) {
                            updatedResponses.push({
                                answer_text: responseKey,
                                sub_responses: []
                            });
                        }
                    } else {
                        updatedResponses = updatedResponses.filter(r => r.answer_text !== responseKey);
                    }
                }

                return {
                    ...prevFormData,
                    form_responses: {
                        ...prevFormData.form_responses,
                        question2: {
                            question_title: "What is the main nature of the employee issue?",
                            responses: updatedResponses
                        }
                    }
                };
            }
        });
    };

    const hasResponse = (responseKey) => {
        return questionState[responseKey]?.selected || false;
    };

    const hasSubResponse = (parentKey, subKey) => {
        return questionState[parentKey]?.subOptions?.[subKey]?.selected || false;
    };

    const hasDeepSubResponse = (grandParentKey, parentKey, subKey) => {
        return questionState[grandParentKey]?.subOptions?.[parentKey]?.subOptions?.[subKey]?.selected || false;
    };

    const getResponseData = (responseKey, dataKey, parentKey = null) => {
        if (parentKey) {
            return questionState[parentKey]?.subOptions?.[responseKey]?.[dataKey] || '';
        }
        return questionState[responseKey]?.[dataKey] || '';
    };

    const getDeepResponseData = (responseKey, dataKey, parentKey, grandParentKey) => {
        return questionState[grandParentKey]?.subOptions?.[parentKey]?.subOptions?.[responseKey]?.[dataKey] || '';
    };
    return (
        <div className="mt-6 border border-gray-200 rounded-lg">
            <div className="flex items-center justify-between p-4 bg-blue-50 rounded-t-lg">
                <h2 className="text-lg font-semibold text-gray-800">
                    Step 3: What is the main nature of the employee issue?
                </h2>
                <span className="text-red-500 text-sm font-medium">Required *</span>
            </div>
            <div>
                <div>
                    <div className="p-2">
                        <div className="space-y-4">
                            <div>
                                <div className="flex items-center">
                                    <input
                                        type="checkbox"
                                        id="functional_impact"
                                        value="Functional impact on role"
                                        className="mr-2"
                                        onChange={(e) => handleQuestionUpdate('Functional impact on role', e.target.checked)}
                                        checked={hasResponse('Functional impact on role')}
                                    />
                                    <label htmlFor="functional_impact" className="text-sm text-gray-700">Functional Impact On Role</label>
                                </div>
                                {hasResponse('Functional impact on role') && (
                                    <div className="mt-2 ml-6 p-3 bg-gray-50 rounded-md">
                                        <div className="space-y-2">
                                            <div className="flex items-center">
                                                <input
                                                    type="checkbox"
                                                    id="reduced_capacity"
                                                    value="Reduced Functional Capacity"
                                                    className="mr-2"
                                                    onChange={(e) => handleQuestionUpdate('Reduced Functional Capacity', e.target.checked, 'Functional impact on role')}
                                                    checked={hasSubResponse('Functional impact on role', 'Reduced Functional Capacity')}
                                                />
                                                <label htmlFor="reduced_capacity" className="text-sm text-gray-700">Reduced Functional Capacity</label>
                                            </div>
                                            <div className="flex items-center">
                                                <input
                                                    type="checkbox"
                                                    id="struggling_demands"
                                                    value="Struggling To Meet Demands Of Role"
                                                    className="mr-2"
                                                    onChange={(e) => handleQuestionUpdate('Struggling To Meet Demands Of Role', e.target.checked, 'Functional impact on role')}
                                                    checked={hasSubResponse('Functional impact on role', 'Struggling To Meet Demands Of Role')}
                                                />
                                                <label htmlFor="struggling_demands" className="text-sm text-gray-700">Struggling To Meet Demands Of Role</label>
                                            </div>
                                            <div className="flex items-center">
                                                <input
                                                    type="checkbox"
                                                    id="requires_adjustments"
                                                    value="Requires Workplace Adjustments"
                                                    className="mr-2"
                                                    onChange={(e) => handleQuestionUpdate('Requires Workplace Adjustments', e.target.checked, 'Functional impact on role')}
                                                    checked={hasSubResponse('Functional impact on role', 'Requires Workplace Adjustments')}
                                                />
                                                <label htmlFor="requires_adjustments" className="text-sm text-gray-700">Requires Workplace Adjustments</label>
                                            </div>
                                            <div className="flex items-center">
                                                <input
                                                    type="checkbox"
                                                    id="safety_concerns"
                                                    value="Safety Concerns"
                                                    className="mr-2"
                                                    onChange={(e) => handleQuestionUpdate('Safety Concerns', e.target.checked, 'Functional impact on role')}
                                                    checked={hasSubResponse('Functional impact on role', 'Safety Concerns')}
                                                />
                                                <label htmlFor="safety_concerns" className="text-sm text-gray-700">Safety Concerns</label>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div>
                                <div className="flex items-center">
                                    <input
                                        type="checkbox"
                                        id="health_factors"
                                        value="Health related factors"
                                        className="mr-2"
                                        onChange={(e) => handleQuestionUpdate('Health related factors', e.target.checked)}
                                        checked={hasResponse('Health related factors')}
                                    />
                                    <label htmlFor="health_factors" className="text-sm text-gray-700">Health Related Factors</label>
                                </div>
                                {hasResponse('Health related factors') && (
                                    <div className="mt-2 ml-6 p-3 bg-gray-50 rounded-md">
                                        <div className="space-y-3">
                                            <div>
                                                <div className="flex items-center">
                                                    <input
                                                        type="checkbox"
                                                        id="mental_health"
                                                        value="Mental health"
                                                        className="mr-2"
                                                        onChange={(e) => handleQuestionUpdate('Mental health', e.target.checked, 'Health related factors')}
                                                        checked={hasSubResponse('Health related factors', 'Mental health')}
                                                    />
                                                    <label htmlFor="mental_health" className="text-sm text-gray-700">Mental Health</label>
                                                </div>
                                                {hasSubResponse('Health related factors', 'Mental health') && (
                                                    <div className="mt-2 ml-6 p-3 bg-gray-50 rounded-md">
                                                        <div className="space-y-2">
                                                            <div className="flex items-center">
                                                                <input
                                                                    type="checkbox"
                                                                    id="anxiety_depression"
                                                                    className="mr-2"
                                                                    onChange={(e) => handleQuestionUpdate('Anxiety/depression', e.target.checked, 'Mental health', null, null, 'Health related factors')}
                                                                    checked={hasDeepSubResponse('Health related factors', 'Mental health', 'Anxiety/depression')}
                                                                />
                                                                <label htmlFor="anxiety_depression" className="text-sm text-gray-700">Anxiety/depression</label>
                                                            </div>
                                                            <div className="flex items-center">
                                                                <input
                                                                    type="checkbox"
                                                                    id="stress_burnout"
                                                                    className="mr-2"
                                                                    onChange={(e) => handleQuestionUpdate('Stress/burnout', e.target.checked, 'Mental health', null, null, 'Health related factors')}
                                                                    checked={hasDeepSubResponse('Health related factors', 'Mental health', 'Stress/burnout')}
                                                                />
                                                                <label htmlFor="stress_burnout" className="text-sm text-gray-700">Stress/burnout</label>
                                                            </div>
                                                            <div className="flex items-center">
                                                                <input
                                                                    type="checkbox"
                                                                    id="other_mental_health"
                                                                    className="mr-2"
                                                                    onChange={(e) => handleQuestionUpdate('Other mental health conditions', e.target.checked, 'Mental health', null, null, 'Health related factors')}
                                                                    checked={hasDeepSubResponse('Health related factors', 'Mental health', 'Other mental health conditions')}
                                                                />
                                                                <label htmlFor="other_mental_health" className="text-sm text-gray-700">Other mental health conditions</label>
                                                            </div>
                                                            {hasDeepSubResponse('Health related factors', 'Mental health', 'Other mental health conditions') && (
                                                                <div className="mt-2 ml-6">
                                                                    <input
                                                                        type="text"
                                                                        id="mentalHealthOther"
                                                                        className="border rounded-md py-1 px-2 w-full text-sm"
                                                                        placeholder="Please specify other mental health condition..."
                                                                        onChange={(e) => handleQuestionUpdate('Other mental health conditions', null, 'Mental health', 'text_response', e.target.value, 'Health related factors')}
                                                                        value={getDeepResponseData('Other mental health conditions', 'text_response', 'Mental health', 'Health related factors')}
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            <div>
                                                <div className="flex items-center">
                                                    <input
                                                        type="checkbox"
                                                        id="neurodiversity"
                                                        value="Neurodiversity"
                                                        className="mr-2"
                                                        onChange={(e) => handleQuestionUpdate('Neurodiversity', e.target.checked, 'Health related factors')}
                                                        checked={hasSubResponse('Health related factors', 'Neurodiversity')}
                                                    />
                                                    <label htmlFor="neurodiversity" className="text-sm text-gray-700">Neurodiversity</label>
                                                </div>
                                                {hasSubResponse('Health related factors', 'Neurodiversity') && (
                                                    <div className="mt-2 ml-6 p-3 bg-gray-50 rounded-md">
                                                        <div className="space-y-2">
                                                            <div className="flex items-center">
                                                                <input
                                                                    type="checkbox"
                                                                    id="adhd"
                                                                    className="mr-2"
                                                                    onChange={(e) => handleQuestionUpdate('ADHD', e.target.checked, 'Neurodiversity', null, null, 'Health related factors')}
                                                                    checked={hasDeepSubResponse('Health related factors', 'Neurodiversity', 'ADHD')}
                                                                />
                                                                <label htmlFor="adhd" className="text-sm text-gray-700">ADHD</label>
                                                            </div>
                                                            <div className="flex items-center">
                                                                <input
                                                                    type="checkbox"
                                                                    id="autism"
                                                                    className="mr-2"
                                                                    onChange={(e) => handleQuestionUpdate('Autism', e.target.checked, 'Neurodiversity', null, null, 'Health related factors')}
                                                                    checked={hasDeepSubResponse('Health related factors', 'Neurodiversity', 'Autism')}
                                                                />
                                                                <label htmlFor="autism" className="text-sm text-gray-700">Autism</label>
                                                            </div>
                                                            <div className="flex items-center">
                                                                <input
                                                                    type="checkbox"
                                                                    id="other_neurodiversity"
                                                                    className="mr-2"
                                                                    onChange={(e) => handleQuestionUpdate('Other neurodiversity', e.target.checked, 'Neurodiversity', null, null, 'Health related factors')}
                                                                    checked={hasDeepSubResponse('Health related factors', 'Neurodiversity', 'Other neurodiversity')}
                                                                />
                                                                <label htmlFor="other_neurodiversity" className="text-sm text-gray-700">Other neurodiversity</label>
                                                            </div>
                                                            {hasDeepSubResponse('Health related factors', 'Neurodiversity', 'Other neurodiversity') && (
                                                                <div className="mt-2 ml-6">
                                                                    <input
                                                                        type="text"
                                                                        id="neurodiversityOther"
                                                                        className="border rounded-md py-1 px-2 w-full text-sm"
                                                                        placeholder="Please specify other neurodiversity..."
                                                                        onChange={(e) => handleQuestionUpdate('Other neurodiversity', null, 'Neurodiversity', 'text_response', e.target.value, 'Health related factors')}
                                                                        value={getDeepResponseData('Other neurodiversity', 'text_response', 'Neurodiversity', 'Health related factors')}
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            <div>
                                                <div className="flex items-center">
                                                    <input
                                                        type="checkbox"
                                                        id="physical_health"
                                                        value="Physical health"
                                                        className="mr-2"
                                                        onChange={(e) => handleQuestionUpdate('Physical health', e.target.checked, 'Health related factors')}
                                                        checked={hasSubResponse('Health related factors', 'Physical health')}
                                                    />
                                                    <label htmlFor="physical_health" className="text-sm text-gray-700">Physical Health</label>
                                                </div>
                                                {hasSubResponse('Health related factors', 'Physical health') && (
                                                    <div className="mt-2 ml-6 p-3 bg-gray-50 rounded-md">
                                                        <div className="space-y-2">
                                                            <div className="flex items-center">
                                                                <input
                                                                    type="checkbox"
                                                                    id="musculoskeletal"
                                                                    className="mr-2"
                                                                    onChange={(e) => handleQuestionUpdate('Musculoskeletal', e.target.checked, 'Physical health', null, null, 'Health related factors')}
                                                                    checked={hasDeepSubResponse('Health related factors', 'Physical health', 'Musculoskeletal')}
                                                                />
                                                                <label htmlFor="musculoskeletal" className="text-sm text-gray-700">Musculoskeletal</label>
                                                            </div>
                                                            <div className="flex items-center">
                                                                <input
                                                                    type="checkbox"
                                                                    id="womens_health"
                                                                    className="mr-2"
                                                                    onChange={(e) => handleQuestionUpdate('Women\'s health', e.target.checked, 'Physical health', null, null, 'Health related factors')}
                                                                    checked={hasDeepSubResponse('Health related factors', 'Physical health', 'Women\'s health')}
                                                                />
                                                                <label htmlFor="womens_health" className="text-sm text-gray-700">Women's health</label>
                                                            </div>
                                                            <div className="flex items-center">
                                                                <input
                                                                    type="checkbox"
                                                                    id="chronic_conditions"
                                                                    className="mr-2"
                                                                    onChange={(e) => handleQuestionUpdate('Chronic conditions', e.target.checked, 'Physical health', null, null, 'Health related factors')}
                                                                    checked={hasDeepSubResponse('Health related factors', 'Physical health', 'Chronic conditions')}
                                                                />
                                                                <label htmlFor="chronic_conditions" className="text-sm text-gray-700">Chronic conditions</label>
                                                            </div>
                                                            <div className="flex items-center">
                                                                <input
                                                                    type="checkbox"
                                                                    id="cancer"
                                                                    className="mr-2"
                                                                    onChange={(e) => handleQuestionUpdate('Cancer', e.target.checked, 'Physical health', null, null, 'Health related factors')}
                                                                    checked={hasDeepSubResponse('Health related factors', 'Physical health', 'Cancer')}
                                                                />
                                                                <label htmlFor="cancer" className="text-sm text-gray-700">Cancer</label>
                                                            </div>
                                                            <div className="flex items-center">
                                                                <input
                                                                    type="checkbox"
                                                                    id="voice_related"
                                                                    className="mr-2"
                                                                    onChange={(e) => handleQuestionUpdate('Voice related', e.target.checked, 'Physical health', null, null, 'Health related factors')}
                                                                    checked={hasDeepSubResponse('Health related factors', 'Physical health', 'Voice related')}
                                                                />
                                                                <label htmlFor="voice_related" className="text-sm text-gray-700">Voice related</label>
                                                            </div>
                                                            <div className="flex items-center">
                                                                <input
                                                                    type="checkbox"
                                                                    id="other_medical_issue"
                                                                    className="mr-2"
                                                                    onChange={(e) => handleQuestionUpdate('Other medical issue', e.target.checked, 'Physical health', null, null, 'Health related factors')}
                                                                    checked={hasDeepSubResponse('Health related factors', 'Physical health', 'Other medical issue')}
                                                                />
                                                                <label htmlFor="other_medical_issue" className="text-sm text-gray-700">Other medical issue</label>
                                                            </div>
                                                            {hasDeepSubResponse('Health related factors', 'Physical health', 'Other medical issue') && (
                                                                <div className="mt-2 ml-6">
                                                                    <input
                                                                        type="text"
                                                                        id="physicalHealthOther"
                                                                        className="border rounded-md py-1 px-2 w-full text-sm"
                                                                        placeholder="Please specify other medical issue..."
                                                                        onChange={(e) => handleQuestionUpdate('Other medical issue', null, 'Physical health', 'text_response', e.target.value, 'Health related factors')}
                                                                        value={getDeepResponseData('Other medical issue', 'text_response', 'Physical health', 'Health related factors')}
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div>
                                <div className="flex items-center">
                                    <input
                                        type="checkbox"
                                        id="personal_circumstances"
                                        value="Personal circumstances"
                                        className="mr-2"
                                        onChange={(e) => handleQuestionUpdate('Personal circumstances', e.target.checked)}
                                        checked={hasResponse('Personal circumstances')}
                                    />
                                    <label htmlFor="personal_circumstances" className="text-sm text-gray-700">Personal Circumstances</label>
                                </div>
                                {hasResponse('Personal circumstances') && (
                                    <div className="mt-2 ml-6 p-3 bg-gray-50 rounded-md">
                                        <div className="space-y-2">
                                            <div className="flex items-center">
                                                <input
                                                    type="checkbox"
                                                    id="caring_responsibilities"
                                                    value="Caring Responsibilities"
                                                    className="mr-2"
                                                    onChange={(e) => handleQuestionUpdate('Caring Responsibilities', e.target.checked, 'Personal circumstances')}
                                                    checked={hasSubResponse('Personal circumstances', 'Caring Responsibilities')}
                                                />
                                                <label htmlFor="caring_responsibilities" className="text-sm text-gray-700">Caring Responsibilities</label>
                                            </div>
                                            <div className="flex items-center">
                                                <input
                                                    type="checkbox"
                                                    id="life_changes"
                                                    value="Life Changes – Bereavement, Separation, Health Concerns Etc"
                                                    className="mr-2"
                                                    onChange={(e) => handleQuestionUpdate('Life Changes – Bereavement, Separation, Health Concerns Etc', e.target.checked, 'Personal circumstances')}
                                                    checked={hasSubResponse('Personal circumstances', 'Life Changes – Bereavement, Separation, Health Concerns Etc')}
                                                />
                                                <label htmlFor="life_changes" className="text-sm text-gray-700">Life Changes – Bereavement, Separation, Health Concerns Etc</label>
                                            </div>
                                            <div className="flex items-center">
                                                <input
                                                    type="checkbox"
                                                    id="circumstances_impacting_work"
                                                    value="Personal Circumstances Impacting Work"
                                                    className="mr-2"
                                                    onChange={(e) => handleQuestionUpdate('Personal Circumstances Impacting Work', e.target.checked, 'Personal circumstances')}
                                                    checked={hasSubResponse('Personal circumstances', 'Personal Circumstances Impacting Work')}
                                                />
                                                <label htmlFor="circumstances_impacting_work" className="text-sm text-gray-700">Personal Circumstances Impacting Work</label>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div>
                                <div className="flex items-center">
                                    <input
                                        type="checkbox"
                                        id="wellbeing_concerns"
                                        value="Wellbeing concerns"
                                        className="mr-2"
                                        onChange={(e) => handleQuestionUpdate('Wellbeing concerns', e.target.checked)}
                                        checked={hasResponse('Wellbeing concerns')}
                                    />
                                    <label htmlFor="wellbeing_concerns" className="text-sm text-gray-700">Wellbeing Concerns</label>
                                </div>
                                {hasResponse('Wellbeing concerns') && (
                                    <div className="mt-2 ml-6 p-3 bg-gray-50 rounded-md">
                                        <div className="space-y-2">
                                            <div className="flex items-center">
                                                <input
                                                    type="checkbox"
                                                    id="wellbeing_support_request"
                                                    value="Request For Wellbeing Support"
                                                    className="mr-2"
                                                    onChange={(e) => handleQuestionUpdate('Request For Wellbeing Support', e.target.checked, 'Wellbeing concerns')}
                                                    checked={hasSubResponse('Wellbeing concerns', 'Request For Wellbeing Support')}
                                                />
                                                <label htmlFor="wellbeing_support_request" className="text-sm text-gray-700">Request For Wellbeing Support</label>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div>
                                <div className="flex items-center">
                                    <input
                                        type="checkbox"
                                        id="other_factors"
                                        value="Other factors"
                                        className="mr-2"
                                        onChange={(e) => handleQuestionUpdate('Other factors', e.target.checked)}
                                        checked={hasResponse('Other factors')}
                                    />
                                    <label htmlFor="other_factors" className="text-sm text-gray-700">Other Factors (Please State)</label>
                                </div>
                                {hasResponse('Other factors') && (
                                    <div className="mt-2 ml-6">
                                        <textarea
                                            id="issueNatureOther"
                                            name="issueNatureOther"
                                            rows="2"
                                            className="border rounded-md py-2 px-4 w-full resize-vertical"
                                            placeholder="Please specify other factors..."
                                            onChange={(e) => handleQuestionUpdate('Other factors', null, null, 'text_response', e.target.value)}
                                            value={getResponseData('Other factors', 'text_response')}
                                        ></textarea>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IssueNatureQuestion;